import React, {useRef, useState} from "react";
import moment from "moment";
import {Overlay, Tooltip} from "react-bootstrap";
import {FormattedMessage} from "react-intl";

interface DaysUntilColumnProps {
    submissionId: string;
    date: string;
}

/**
 * Rendert die "Bearbeitbar"-Tabellen-Zelle für das Einreichungslisting
 *
 * @constructor
 */
const DaysUntilColumn: ({submissionId, date}: DaysUntilColumnProps) => JSX.Element = (
    {submissionId, date}: DaysUntilColumnProps
) => {
    const target = useRef(null);
    const [show, setShow] = useState(false);

    /**
     * Toggled den "show"-state des Tooltips
     */
    const toggleTooltip = () => {
        setShow(!show);
    }

    const now = moment();
    const editDate = moment(date)
    const diffInDays: number = editDate.diff(now, 'days');

    /**
     * Formatiert die Anzahl der noch übrigen Tage als i18n Text
     *
     * @param diff - Anzahl verbleibender Tage
     */
    const formatAmountOfEditableDays = (diff: number) => {
        return <FormattedMessage id="myarea.listing.column.body.editableUntil" values={{dayCount: diff}}/>
    }

    return (
        <>
            <span ref={target} onMouseEnter={toggleTooltip} onMouseLeave={toggleTooltip}>
                {diffInDays > 0
                    ? formatAmountOfEditableDays(diffInDays)
                    : <i className='fa fa-2x fa-ban'/>}
            </span>
            <Overlay target={target.current} show={show} placement='right'>
                {(props) => (
                    <Tooltip id={'tooltip-' + submissionId} {...props}>
                        {editDate.format('DD.MM.YYYY')}
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
}

export default DaysUntilColumn;
